/* eslint-disable no-undef */
const FormsValidation = (function () {
  function init() {
    jQuery("form").on("change", ".custom-choice-with-validation", function () {
      jQuery(".custom-choice-with-validation").each(function () {
        const el = this as HTMLInputElement;
        const textBoxId = el.getAttribute("data-validate-id");
        const validateText = el.getAttribute("data-validate-text");

        if (el.checked && validateText === "True") {
          // add validation
          addEpiRequiredValidatorToElement(textBoxId);
        } else {
          const epiForm = document.getElementsByClassName("EPiServerForms");
          if (epiForm === undefined || epiForm.length === 0) return;

          // remove validation
          removeItemByAttribute(
            window.epi.EPiServer.Forms[epiForm[0].id].ValidationInfo,
            "targetElementId",
            textBoxId,
          );
        }
      });
    });
  }

  const removeItemByAttribute = function (
    arr: [],
    attr: string,
    value: unknown,
  ) {
    let i = arr.length;
    while (i--) {
      if (
        arr[i] &&
        Object.prototype.hasOwnProperty.call(arr[i], attr) &&
        arguments.length > 2 &&
        arr[i][attr] === value
      ) {
        arr.splice(i, 1);
      }
    }
    return arr;
  };
  const addEpiRequiredValidatorToElement = function (id: string | null) {
    const validator = {
      targetElementName: "__field_" + id,
      targetElementId: id,
      validators: [
        {
          type: "EPiServer.Forms.Implementation.Validation.RequiredValidator",
          description: null,
          model: {
            message: "Fältet är obligatoriskt.",
            validationCssClass: "ValidationRequired",
            additionalAttributes: null,
          },
        },
      ],
    };

    const epiForm = document.getElementsByClassName("EPiServerForms");
    if (epiForm === undefined || epiForm.length === 0) return;

    window.epi.EPiServer.Forms[epiForm[0].id].ValidationInfo.push(validator);
  };

  return {
    init,
  };
})();

export default FormsValidation;
